import {
  AddressApi,
  Configuration,
  ContactApi,
  MenuApi,
  PhoneApi,
  SliderApi,
} from '@generated-client/strapi';

export * from '@generated-client/strapi/models';

const config = new Configuration({
  basePath: '/strapi/api',
});

const ssrConfig = new Configuration({
  basePath: 'https://www.trwl.store/strapi/api',
});

export const STRAPI_API = {
  MenuApi: new MenuApi(config),
  AddressApi: new AddressApi(config),
  ContactApi: new ContactApi(config),
  PhoneApi: new PhoneApi(config),
  SliderApi: new SliderApi(config),
};

export const SSR_STRAPI_API = {
  MenuApi: new MenuApi(ssrConfig),
  AddressApi: new AddressApi(ssrConfig),
  ContactApi: new ContactApi(ssrConfig),
  PhoneApi: new PhoneApi(ssrConfig),
  SliderApi: new SliderApi(ssrConfig),
};
